<template>
  <v-dialog v-model="showDialog" max-width="320px" persistent>
    <v-card flat>
      <v-icon class="close" @click.prevent="showDialog = false; $emit('close')">$sl-close</v-icon>
      <h2>{{$t('ebook.change-instructor')}}</h2>

      <v-list class="mt-4" flat>
        <v-list-item-group v-model="instructorId" :multiple="false" :mandatory="false">
          <template v-for="(item, index) in InstructorList">
            <v-list-item :key="item.id" :value="item.id">
              <v-list-item-icon>
                <v-icon>$sl-instructor</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-4">
                <v-list-item-title v-html="item.fullName"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <div class="v-list-item__radio">
                  <input type="radio" v-model="instructorId" :value="item.id" />
                  <div class="check">
                    <div class="inside"></div>
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="`divider-${index}`" v-if="(index+1) < InstructorList.length"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
      <div class="d-flex justify-space-between mt-6">
        <ActionButton
          
          :block="false"
          type="application"
          actionIcon="$sl-cancel"
          @click="showDialog = false; $emit('close')"
        >{{ $t('labels.cancel') }}</ActionButton>
        <ActionButton
          :isDisabled="isImitatingUser()"
          :block="false"
          @click="saveClick"
          actionIcon="$sl-instructor"
        >{{$t('labels.change')}}</ActionButton>
      </div>
      <v-card-text>{{$t('ebook.change-instructor-text')}}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import {mapActions, mapGetters} from 'vuex'
import filter from 'lodash/filter'
import find from 'lodash/find'

// @group Common
// Styled SelectInstructorModal component
export default {
  name: 'SelectInstructorModal',
  props: {
    //is it showed
    show: false,
    //has instructor id
    instId: {
      // `'Integer'`
      type: Number,
      // The default value is: `0`
      default: 0
    },
    //has profession id
    professionId: {
      // `'Integer'`
      type: Number,
      // The default value is: `null`
      default: 0
    },
    //has company id
    companyId: {
      // `'Integer'`
      type: Number,
      // The default value is: `null`
      default: 0
    }
  },

  data: () => ({
    showDialog: false,
    instructorId: 0,
    InstructorList: [],
    professions: [],
    professionObj: []
  }),

  components: {
    ActionButton
  },

  computed: {
    ...mapGetters('basic', ['basicProfessions']),
    ...mapGetters('currentuser', ['isImitatingUser']),
  },

  created() {
    this.init()
  },

  watch: {
    show(val) {
      this.showDialog = val
      this.init()
      // this.workplace = []
    },
    companyId() {
      this.init()
    }
  },

  methods: {
    init() {
      this.instructorId = this.instId
      if (!this.companyId) {
        return
      }

      this.getProfessions()
    },
    getEmpList() {
      let callName = ''
      if (this.companyId) {
        callName = 'listEmployments'
      }
      // @vuese
      // Used to make a call to db , and return a list of instructors
      // @arg The argument is an id number ( companyId or  apprenticeId )
      API[callName](this.companyId)
        .then(response => {
          //- Instructors must have tradecertificate for chosen profession and not more than allowed apprentices already
          const pi = this.professionObj.id
          const maxApp = this.professionObj.maxApp
          this.InstructorList = filter(response.data, i => {
            const hasProfession = filter(i.employed.tradeCertificates, ['professionId', pi])
            const hasSpace = i.apprentices ? i.apprentices.length : 0 < maxApp
            return hasProfession && hasSpace
          })
          this.InstructorList = this.InstructorList.map(o => {
            return {
              id: o.id,
              firstName: o.employed.firstName,
              lastName: o.employed.lastName,
              fullName: o.employed.firstName + ' ' + o.employed.lastName
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getProfessions() {
      this.professions = this.basicProfessions.map(o => {
        return {id: o.id, text: o.name, maxApp: o.maxApprenticesForInstructor}
      })
      let prof = this.professions.find(x => x.id == this.professionId)
      if (prof) {
        this.professionObj = prof

        this.getEmpList()
      }
    },
    check: function (e) {
      e.cancelBubble = true
    },
    /**
     * @vuese
     * Used to saved certified instructors
     * @arg The argument is an object representing instructor
     */
    saveClick() {
      const inst = find(this.InstructorList, ['id', this.instructorId])
      // Fire instructorCertified with instructor object
      // @arg The argument is a object
      this.$emit('instructorCertified', inst)
      //this.showDialog = false
    }
  }
}
</script>

